import { createTheme } from "@mantine/core";

export const theme = createTheme({
  primaryColor: "dark",
  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
  defaultRadius: "md",
  shadows: {
    xs: "0 1px 2px rgba(0, 0, 0, 0.04)",
    sm: "0 1px 3px rgba(0, 0, 0, 0.06)",
    md: "0 2px 6px rgba(0, 0, 0, 0.06)",
    lg: "0 4px 12px rgba(0, 0, 0, 0.06)",
    xl: "0 8px 24px rgba(0, 0, 0, 0.06)",
  },
  headings: {
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    sizes: {
      h1: { fontSize: "1.5rem" },
      h2: { fontSize: "1.25rem" },
      h3: { fontSize: "1.1rem" },
      h4: { fontSize: "0.95rem" },
    },
  },
  other: {
    borderColor: "var(--mantine-color-gray-2)",
  },
});
